import $http from "@/services/Http";
import { prefix } from "@/api/config";

export function generate(
  projectId: number,
  data: Record<"starts_at" | "ends_at" | "notifications", unknown>
) {
  return $http.post(`${prefix}/projects/${projectId}/reports-generate`, data);
}
